
shadow.loader.set_load_start('age-encryption');